import React from 'react'
import {Button, Media} from "reactstrap";
import dateHelpers from "../../helpers/DateHelper";
import {MdDelete, MdEdit, MdEmail, MdVisibility} from 'react-icons/md';

const propTypes = {};

class InvoiceReportRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            invoice: props.invoice,
            currency: props.currency
        };

    }

    render() {
        return (
            <tr>
                <th scope="row">

                    <Media className="align-items-center">
                        <Media>
                            <span className="mb-0 text-sm">
                                <a href="#" onClick={e => this.props.onInvoiceSelected(e, this.state.invoice)}
                                   style={{cursor: "pointer"}}>{this.state.invoice && this.state.invoice.number ? this.state.invoice.number : "..."} </a>
                            </span>
                        </Media>
                    </Media>
                </th>
                <td>
                    <span className="mb-0 text-sm">
                        {this.state.invoice && this.state.invoice.client_name ? this.state.invoice.client_name.substring(0, 30) : "..."}
                    </span>
                </td>

                <td>
                    <span className="mb-0 text-sm">
                        {this.price()}
                    </span>
                </td>

                <td>
                    <span className="mb-0 text-sm">
                        {dateHelpers.formatDate(new Date(this.state.invoice.date))}
                    </span>
                </td>
                <td className="text-right align-content-end">
                    <Button className="btn-icon" color="secondary"
                            onClick={e => this.props.onInvoiceSelected(e, this.state.invoice)}>
                        <MdVisibility/>
                    </Button>

                    <Button className="btn-icon" color="secondary"
                            onClick={e => this.props.editInvoice(e, this.state.invoice)}>
                        <MdEdit/>
                    </Button>

                    <Button className="btn-icon" color="info"
                            onClick={e => this.props.sendInvoice(e, this.state.invoice)}>
                        <MdEmail/>
                    </Button>

                    <Button className="btn-icon" color="warning"
                            onClick={e => this.props.deleteInvoice(e, this.state.invoice)}>
                        <MdDelete/>
                    </Button>
                </td>
            </tr>
        )
    }

    price() {
        return this.state.currency + (parseFloat(this.state.invoice && this.state.invoice.display_total ? this.state.invoice.display_total : "0")).toFixed(2)
    }
}

InvoiceReportRow.propTypes = propTypes;

export default InvoiceReportRow;